import ApiUtils from "api/Utils";
import { getCachedData } from "api/Cache";
import { updateData } from "services/CacheService";
import { handleLayers, handleLayerEvent } from "actions/ViewerTools";
import ViewsActions from "./ViewsActions";
import ViewerActions from "./ViewerActions";
import ViewerEvents from "events/ViewerEvents";
import EventsActions from "events/EventsEmitter";
import { defaultViewProgram, filterTypes, filterModelWorkflow } from "constants/viewer";
import * as Utils from "services/UtilsService";

class Folder {
    ID = "";
    name = "";
    level = 0;
    status = "expand";
    view_type = "folder";
    visible = true;
    disabled = false;
    children = [] as any;
    parent = null;
    constructor(
        id: string,
        name: string,
        level: number,
        status: string,
        visible: boolean,
        disabled: boolean,
        children: any,
        parent: any,
        view_type?: string
    ) {
        this.ID = id;
        this.name = name;
        this.level = level;
        this.status = status;
        this.visible = visible;
        this.disabled = disabled;
        this.children = children;
        this.parent = parent;
        this.view_type = view_type ? view_type : "folder";
    }
}

const rootFolder = [
    {
        ID: "0",
        view_type: "folder",
        name: "Root",
        status: "expand",
        visible: true,
        level: 0,
        children: [],
    },
];

export default class LayersActions extends EventsActions {
    static layers: any = [];
    static selectedLayers: any = [];
    static folders: any = [];
    static attributes: any = [];
    static entitiesData: any = [];
    static data: any = [];
    static processed: any = [];
    static needsUpdate: boolean = false;
    static draggedLayerId: string = "";
    static draggedFolder: string = "";
    static multipleSelection = false;
    static startLayerSelect: any = null;
    static foldersTree: any = rootFolder;
    static initliaze: boolean = false;

    static reset() {
        LayersActions.selectedLayers = [];
        LayersActions.folders = [];
        LayersActions.draggedFolder = "";
        LayersActions.draggedLayerId = "";
        LayersActions.needsUpdate = true;
        LayersActions.initliaze = false;
    }
    static destroy() {
        LayersActions.reset();
        LayersActions.layers = [];
        LayersActions.needsUpdate = false;
        console.log("cleanup LayersAction done...");
    }

    static constructTree = (layers: any, folders?: any) => {
        //console.log('LayersActions.contructTree:', layers);
        if (!folders) {
            folders = LayersActions.folders;
        }
        if (
            LayersActions.initliaze &&
            LayersActions.foldersTree &&
            LayersActions.foldersTree[0].children.length !== 0 &&
            Utils.arrayEqualValues(layers, LayersActions.layers) &&
            Utils.arrayEqualValues(folders, LayersActions.folders) &&
            !LayersActions.needsUpdate
        ) {
            return LayersActions.foldersTree;
        }

        const FOLDER_ID_ROOT = "0";
        var foldersTree: any = [];
        const flatTree: any = [];

        foldersTree[FOLDER_ID_ROOT] = new Folder(FOLDER_ID_ROOT, "Root", 0, "expand", true, false, [], null);
        const getRootParent = (layer: any, level: number) => {
            let root;
            let currentLevel = 0;
            const getRoot = (layer: any) => {
                if (layer.view_folder && layer.view_folder !== "0") {
                    currentLevel++;
                    let parent = ViewerEvents.findElement(layer.view_folder);
                    if (parent) {
                        if (currentLevel <= level) {
                            root = parent;
                            getRoot(parent);
                        }
                    }
                }
            };
            getRoot(layer);
            return root;
        };

        const findLevel = (layer: any) => {
            let level = 0;
            const getLevel = (layer: any) => {
                if (layer.view_folder && layer.view_folder !== "0") {
                    level++;
                    let parent = ViewerEvents.findElement(layer.view_folder);
                    if (parent) {
                        getLevel(parent);
                    }
                }
            };
            getLevel(layer);
            return level;
        };

        const constructTree = (layer: any) => {
            let currentNode = foldersTree[0];
            let folderId = layer.view_folder;
            const maxLevel = findLevel(layer);
            let level = maxLevel;
            let currentLevel = 0;
            const buildTree = () => {
                if (level > 0) {
                    const parent: any = getRootParent(layer, level);
                    if (parent) {
                        //console.log('parent:', parent);
                        currentLevel++;
                        if (!flatTree[parent.ID]) {
                            const newFolder = new Folder(
                                parent.ID,
                                parent.name,
                                currentLevel,
                                "expand",
                                true,
                                false,
                                [],
                                rootFolder,
                                parent.view_type
                            );
                            if (parent.ID === folderId) {
                                newFolder.children.push(layer);
                            }
                            currentNode.children.push(newFolder);
                            flatTree[parent.ID] = newFolder;
                            currentNode = newFolder;
                        } else {
                            if (parent.ID === folderId) {
                                const currentFolder = flatTree[parent.ID];
                                currentFolder.children.push(layer);
                            }
                        }
                    }
                    level--;
                    buildTree();
                }
            };
            buildTree();
        };

        layers = Utils.cleanArray(layers);
        layers = Utils.uniqueArray(layers);
        Object.values(layers).forEach((layer: any) => {
            if (layer) {
                //console.log('layer:', layer);
                if (layer.view_folder === "0" || !layer.view_folder) {
                    foldersTree[0].children.push(layer);
                } else {
                    constructTree(layer);
                }
            }
        });
        console.log("foldersTree:", foldersTree);
        LayersActions.folders = [...folders];
        LayersActions.layers = [...Object.values(layers)];
        LayersActions.foldersTree = [...foldersTree];
        LayersActions.needsUpdate = false;
        LayersActions.initliaze = true;
    };

    static updateTreeAction = (foldersTree: any, matchingID: string, action: any) => {
        var result: any;
        function findResult(currentTree: any, matchingID: string) {
            currentTree.forEach((entry: any) => {
                if (entry.ID === matchingID) {
                    result = entry;
                    action(entry);
                    return entry;
                }
                if (entry.children && !result) {
                    findResult(entry.children, matchingID);
                }
            });
        }
        if (matchingID === "0") {
            action(foldersTree[0]);
            return foldersTree;
        }
        findResult(foldersTree[0].children, matchingID);
        return foldersTree;
    };

    static getProjectELement = (id: string) => {
        return ViewsActions.findElement(ViewerActions.projectId, id);
    };

    static createFolder(view: any, done: (folder: any) => void) {
        var projectId = view.project;
        var selectedView = view.ID;
        var { selectedLayers } = LayersActions;

        var processFolder = (parentFolderId: string) => {
            ApiUtils.serverCreateId((folderId: string) => {
                let folder = {
                    ID: folderId,
                    entity_container: "",
                    file_date: new Date().getTime() + "",
                    file_folder: "0",
                    file_type: "VIEW",
                    name: "New Folder",
                    project: projectId,
                    state: "COMPLETE",
                    type: "FILE",
                    view_type: "folder",
                    view_folder: parentFolderId,
                    view_ref: view.ID,
                };

                selectedLayers.forEach((layer: any) => {
                    layer.view_folder = folder.ID;
                });

                updateData("create", "entities", projectId, folder);
                updateData("update", "views", selectedView, view);
                updateData("updateEntity", "entities", projectId, view);
                LayersActions.folders.push(folder);
                LayersActions.needsUpdate = true;
                done(folder);
            });
        };
        var parentFolders = selectedLayers.map((layer: any) => {
            return layer.view_folder;
        });
        parentFolders = Utils.cleanArray(Utils.uniqueArray(parentFolders));
        if (parentFolders.length === 0 || parentFolders.length > 1) {
            processFolder("0");
        } else {
            processFolder(parentFolders[0]);
        }
    }
    static moveToFolder = (folderId: string) => {
        //console.log('moveToFolder:', folderId, '|', LayersActions.selectedLayers);
        var selectedLayers = LayersActions.selectedLayers;
        if (selectedLayers.length === 0) {
            var draggedLayer = LayersActions.findItemById(LayersActions.draggedLayerId);
            if (draggedLayer) {
                selectedLayers.push(draggedLayer);
            }
        }
        console.log("selectedLayers:", selectedLayers);
        selectedLayers.forEach((layer: any) => {
            layer["view_folder"] = folderId;
        });
    };

    static getFoldersList = () => {
        const foldersTree = [...LayersActions.foldersTree];
        var foldersList: any = [];
        if (foldersTree) {
            foldersTree.filter(function f(item: any) {
                if (item["view_type"] === "folder" || item["view_type"] === "collection") {
                    foldersList.push(item);
                }
                if (item.children) {
                    return (item.children = item.children.filter(f)).length;
                }
                return undefined;
            });
        }
        return foldersList;
    };

    static getChildren = (folderId: string) => {
        var children: any = [];

        const findChildren = (itemId: string) => {
            var currentItem = LayersActions.getProjectELement(itemId);
            if (currentItem) {
                children.push(currentItem);
                if (currentItem.view_type === "folder" || currentItem.view_type === "collection") {
                    var currentFolder = LayersActions.findItemById(itemId);
                    if (currentFolder) {
                        for (var index in currentFolder.children) {
                            var child = currentFolder.children[index];
                            findChildren(child.ID);
                        }
                    }
                }
            }
        };
        findChildren(folderId);
        return children;
    };

    static updateTree = (newTree: any) => {
        LayersActions.foldersTree = newTree;
    };

    static findParentById = (matchingID: string) => {
        var result: any;
        function findResult(currentTree: any, matchingID: string) {
            currentTree.forEach((entry: any) => {
                if (entry.ID === matchingID) {
                    result = currentTree;
                    return currentTree;
                }
                if (entry.children && !result) {
                    findResult(entry.children, matchingID);
                }
            });
        }
        var foldersTree = LayersActions.foldersTree;
        if (matchingID === "0") {
            return foldersTree[0];
        }
        findResult(foldersTree[0].children, matchingID);
        return result;
    };

    static findItemById = (matchingID: string) => {
        var result: any;
        function findResult(currentTree: any, matchingID: string) {
            currentTree.forEach((entry: any) => {
                if (entry.ID === matchingID) {
                    result = entry;
                    return entry;
                }
                if (entry.children && !result) {
                    findResult(entry.children, matchingID);
                }
            });
        }
        var foldersTree = Utils.cleanObject(LayersActions.foldersTree);
        if (matchingID === "0") {
            return foldersTree[0];
        }
        findResult(foldersTree[0].children, matchingID);
        return result;
    };

    static findSpecificItemById = (foldersTree: any, matchingID: string) => {
        var result: any;
        function findResult(currentTree: any, matchingID: string) {
            currentTree.forEach((entry: any) => {
                if (entry.ID === matchingID) {
                    result = entry;
                    return entry;
                }
                if (entry.children && !result) {
                    findResult(entry.children, matchingID);
                }
            });
        }
        if (matchingID === "0") {
            return foldersTree[0];
        }
        findResult(foldersTree[0].children, matchingID);
        return result;
    };

    static findFolderByLevel = (foldersTree: any, level: number) => {
        var result: any = [];
        function findResult(currentTree: any, level: number) {
            currentTree.forEach((entry: any) => {
                if (entry.level === level) {
                    result.push(entry);
                }
                if (entry.children) {
                    findResult(entry.children, level);
                }
            });
        }
        findResult(foldersTree[0].children, level);
        return result;
    };

    static findMaxLevel = (foldersTree: any, folderId: string) => {
        var maxLevel = 0;
        function findResult(folder: any) {
            maxLevel = folder.level;
            if (folder.children) {
                folder.children.forEach((item: any) => {
                    if (item.view_type === "folder") {
                        findResult(item);
                    }
                });
            }
        }
        var currentFolder = LayersActions.findSpecificItemById(foldersTree, folderId);
        findResult(currentFolder);
        return maxLevel;
    };

    static moveLayerToFolder = (sourceLayerId: string, targetFolder: string, done?: () => void) => {
        /*
		console.log(
			'moveLayerToFolder.sourceLayer:',
			sourceLayerId,
			'|targetFolder:',
			targetFolder
		);
		*/
        var { layers } = LayersActions;
        var srcLayer = layers.find((layer: any) => layer.ID === sourceLayerId);
        var draggedLayers = LayersActions.selectedLayers;
        if (draggedLayers.length > 0) {
            draggedLayers.forEach((layer: any) => {
                layer.view_folder = targetFolder;
            });
        } else {
            if (srcLayer) {
                srcLayer.view_folder = targetFolder;
            }
        }
        LayersActions.triggerUpdateTree(layers);
        if (done) {
            done();
        }
    };

    static shuffleLayers = (sourceLayerId: string, targetLayerId: string, done: () => void) => {
        /*
		console.log(
			'shuffleLayers.sourceLayer:',
			sourceLayerId,
			'|targetLayerId:',
			targetLayerId
		);*/
        var { layers } = LayersActions;
        var srcIndex = layers.findIndex((layer: any) => layer.ID === sourceLayerId);
        var targetIndex = layers.findIndex((layer: any) => layer.ID === targetLayerId);

        if (srcIndex > -1 && targetIndex > -1) {
            layers.splice(targetIndex, 0, layers.splice(srcIndex, 1)[0]);
            LayersActions.triggerUpdateTree(layers);
            if (done) {
                done();
            }
        }
    };

    static dropLayer = (sourceLayerId: string, targetLayerId: string, done: () => void) => {
        var targetLayer = LayersActions.findItemById(targetLayerId);
        var srcLayer = LayersActions.findItemById(sourceLayerId);
        var draggedLayers = LayersActions.selectedLayers;
        var handleAction = (srcLayer: any) => {
            if (srcLayer && targetLayer) {
                if (srcLayer.view_folder === targetLayer.view_folder) {
                    LayersActions.shuffleLayers(sourceLayerId, targetLayerId, done);
                } else {
                    LayersActions.moveLayerToFolder(sourceLayerId, targetLayer.view_folder, done);
                }
            }
        };
        if (draggedLayers.length > 0) {
            draggedLayers.forEach((layer: any) => {
                handleAction(layer);
            });
        } else {
            handleAction(srcLayer);
        }
    };

    static dropFolder = (sourceFolderId: string, targetFolderId: string, done?: () => void) => {
        var { layers, folders } = LayersActions;
        var srcFolder = folders.find((folder: any) => folder.ID === sourceFolderId);
        if (srcFolder) {
            srcFolder.view_folder = targetFolderId;
            LayersActions.triggerUpdateTree(layers, folders);
            if (done) {
                done();
            }
        }
    };

    static getChildrenCount = (folderId: string) => {
        var layersChildren = LayersActions.layers.filter((layer: any) => layer.view_folder === folderId);
        var foldersChildren = LayersActions.folders.filter((folder: any) => folder.view_folder === folderId);
        return layersChildren.length + foldersChildren.length;
    };

    static renameFolder = (ID: string, projectId: string, name: string, done?: () => void) => {
        var foldersTree = LayersActions.foldersTree;
        var currentFolder: any = LayersActions.findItemById(ID);
        LayersActions.updateTree(foldersTree);
        var item = getCachedData("entities")[projectId][ID];
        let isUpdated = false;
        if (item) {
            isUpdated = item.name.toUpperCase().trim() !== name.toUpperCase().trim();
            item.name = name;
        }
        if (currentFolder) {
            currentFolder.name = name;
        }
        if(!isUpdated) return;

        updateData("updateEntity", "entities", projectId, item);
        handleLayerEvent("changeLayerName", { labelName: name }, item);
        done && done();
    };

    static triggerUpdateTree = (layers: any, folders?: any) => {
        LayersActions.needsUpdate = true;
        if (!folders) {
            folders = LayersActions.folders;
        }
        LayersActions.constructTree(layers, folders);
        LayersActions.emit("updateTree", layers);
    };

    static deleteFolder = (folderId: string, done: () => void) => {
        var children: any = LayersActions.getChildren(folderId);
        //console.log('children:', children);
        var { layers, folders } = LayersActions;
        children.forEach((child: any) => {
            if (child.view_type === "folder" || child.view_type === "collection") {
                child.view_ref = "0";
                var folderIndex = folders.findIndex((folder: any) => folder.ID === child.ID);
                if (folderIndex > -1) {
                    folders.splice(folderIndex, 1);
                }
            } else {
                var layer: any = layers.find((layer: any) => layer.ID === child.ID);
                layer.view_folder = "0";
            }
        });

        LayersActions.needsUpdate = true;
        LayersActions.emit("updateTree", layers);
        done();
    };

    static toggleVisibility = (folderId: string, visibility: string) => {
        var children: any = LayersActions.getChildren(folderId);
        var { layers } = LayersActions;
        children.forEach((child: any) => {
            if (child.view_type === "folder") {
                var currentFolder: any = LayersActions.findItemById(child.ID);
                currentFolder.disabled = visibility === "0";
            } else {
                var layer = layers.find((curLayer: any) => curLayer.ID === child.ID);
                if (layer) {
                    layer["layer_visible"] = visibility;
                    handleLayerEvent("toggleVisibility", null, layer);
                }
            }
        });
        LayersActions.needsUpdate = true;
        handleLayers(layers);
    };

    static setTransparency = (transparency: number, layerId: string) => {
        var { layers } = LayersActions;
        var currentLayer = layers.find((layer: any) => {
            return layer.ID === layerId;
        });
        if (currentLayer) {
            currentLayer["layer_opacity"] = transparency + "";
            handleLayerEvent("setTransparency", null, currentLayer);
            LayersActions.emit("updateLayer", currentLayer);
        }
    };

    static renameLayer = (ID: string, projectId: string, name: string) => {
        var layer = getCachedData("entities")[projectId][ID];
        if (layer) {
            layer.name = name;
        }
        updateData("updateEntity", "entities", projectId, layer);
    };

    static addSelectedLayers = (endLayer: any, done: any) => {
        var startLayer = LayersActions.startLayerSelect;
        if (!startLayer || !endLayer) {
            return;
        }
        var layers: any;

        if (startLayer.hasOwnProperty("parent_layer")) {
            const mesh = ViewerActions.compositeMeshes[startLayer.parent_layer];
            var { subLayers } = mesh;
            layers = subLayers;
        } else {
            layers = LayersActions.layers;
        }
        var startIndex = layers.findIndex((layer: any) => layer.ID === startLayer.ID);
        var endIndex = layers.findIndex((layer: any) => layer.ID === endLayer.ID);
        if (startIndex === -1 || endIndex === -1) {
            return;
        }
        var min: number = Math.min(startIndex, endIndex);
        var max: number = Math.max(startIndex, endIndex);
        //console.log(startLayer.name, '|', endLayer.name);
        //console.log(min, '|', max);
        var selectedLayers: any = [];
        layers.forEach((layer: any, index: number) => {
            if (index >= min && index <= max) {
                selectedLayers.push(layer);
            }
        });
        LayersActions.selectedLayers = selectedLayers;
        //console.log(LayersActions.selectedLayers);
        done(selectedLayers);
    };

    static applyOrder(layers: any, orderType: number, swapOrder: boolean) {
        var rawLayers = Object.values(layers);
        if (swapOrder) {
            rawLayers = rawLayers.reverse();
        }
        var weight = (prop: string) => {
            return filterModelWorkflow.findIndex((val: string) => val === prop);
        };
        var sortArrayByModelWorkflow = () => {
            var prop = "view_type";
            return rawLayers.reverse().sort((a: any, b: any) => {
                if (weight(a[prop]) < weight(b[prop])) {
                    return -1;
                }
                if (weight(a[prop]) > weight(b[prop])) {
                    return 1;
                }
                return 0;
            });
        };
        var resultLayers: any = [];

        switch (orderType) {
            case 0:
                resultLayers = Utils.sortArrayByProp(rawLayers, "view_type", swapOrder);
                break;
            case 1:
                resultLayers = Utils.sortArrayByProp(rawLayers, "name", swapOrder);
                break;
            case 2:
                resultLayers = Utils.sortArrayByProp(rawLayers, "file_date", swapOrder);
                break;
            case 3:
                resultLayers = sortArrayByModelWorkflow();
                break;
            case 4:
                resultLayers = rawLayers;
                break;
        }
        return resultLayers;
    }

    static applyFilters(layers: any, filters: any) {
        var currentLayers: any = [...layers];
        var filtered: any = [];
        if (filters.length === 0) {
            return [...layers];
        }
        currentLayers.forEach((layer: any) => {
            filters.forEach((filter: any) => {
                switch (filter.type) {
                    case "show":
                        if (
                            typeof layer["layer_visible"] === "undefined" ||
                            (typeof layer["layer_visible"] !== "undefined" && layer["layer_visible"] === "1")
                        ) {
                            filtered.push(layer);
                        }
                        break;
                    case "text":
                        if (
                            typeof layer["name"] !== "undefined" &&
                            layer["name"].toLowerCase().includes(filter.value.toLowerCase())
                        ) {
                            filtered.push(layer);
                        }
                        break;
                    case "data":
                        var filterType: any = Object.values(filterTypes)[filter.index];
                        var dataType = defaultViewProgram[filterType.type];
                        if (
                            typeof layer["view_type"] !== "undefined" &&
                            (ViewerActions.getInputsId(layer) === dataType || layer["view_type"] === dataType)
                        ) {
                            filtered.push(layer);
                        }
                        break;
                    case "metadata":
                        break;
                    default:
                        break;
                }
            });
        });
        LayersActions.needsUpdate = true;
        return filtered;
    }
}
